// Central content data for Body Evolution 2.0

export const business = {
  name: "Body Evolution 2.0",
  address: "Viale della Libertà, 66, 81030 Lusciano CE",
  phone: "081 012 14 72",
  phoneRaw: "+39081012 14 72".replace(/\s/g, ""),
  whatsapp: "390810121472",
  email: "palestrabodyevolution@gmail.com",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Viale+della+Libert%C3%A0+66+81030+Lusciano+CE",
  mapEmbed: "https://www.google.com/maps?q=Viale%20della%20Libert%C3%A0%2066%2C%2081030%20Lusciano%20CE&output=embed",
};

export const images = {
  hero: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/4899138d6be78afe28f1856a16c4a90c7ecc1aa47c500098c60a66a2226d4f8c.png",
  weightRoom: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/b50baf0d261cb747228f67867b2208a0c3dda4ee74b209a5cbb0518eae070ebb.png",
  holistic: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/5a9a6018770756fc3466ec6fc5211873678ab1240d1cf4dd7a9c7801d1599310.png",
  personalTraining: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/b6a4b093fbcd2cc1870db610c7772779c4d7221bbfea984a22fa1921805f5a3e.png",
  fitnessClass: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/50c9fb6a99dd5cd78b30442f878bd4dd8c6b165cc7071481d1e00e8c2cd6e69f.png",
  kidsFamily: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/1a32f28a747e9c2d98ff54c32519322804cb721ae9faf3030ddba4020ad07b2f.png",
  reception: "https://static.prod-images.emergentagent.com/jobs/190a0210-b5a2-4113-ae3e-cfef8310693f/images/790e16578e2b9490dbe15dd88f69feb2c61170f7a6134568d0b7898c83a201da.png",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "La Palestra", to: "/la-palestra" },
  { label: "Sala Pesi", to: "/sala-pesi" },
  { label: "Personal Training", to: "/personal-training" },
  { label: "Corsi Fitness", to: "/corsi-fitness" },
  { label: "Sala Olistica", to: "/sala-olistica" },
  { label: "Kids & Family", to: "/kids-family" },
  { label: "Professionisti", to: "/professionisti" },
  { label: "Abbonamenti", to: "/abbonamenti" },
  { label: "Contatti", to: "/contatti" },
];

export const heroClaims = [
  "Aperti H24 da settembre",
  "Sala pesi attrezzata",
  "Corsi fitness e olistici",
  "Percorsi personalizzati",
];

export const strengths = [
  { n: "01", title: "Apertura H24 da settembre", text: "Ti alleni quando vuoi, con la libertà di scegliere il tuo momento, ogni giorno della settimana." },
  { n: "02", title: "Istruttori presenti e qualificati", text: "Uno staff reale, in sala, pronto a seguirti con competenza e attenzione." },
  { n: "03", title: "Sala ampia con attrezzi e macchinari", text: "Pesi, macchine e spazi organizzati per allenarti con sicurezza e metodo." },
  { n: "04", title: "Corsi fitness strutturati", text: "Un palinsesto ricco e programmato, per allenarti con energia e continuità." },
  { n: "05", title: "Sala olistica dedicata", text: "Uno spazio pensato per postura, equilibrio, mobilità e benessere profondo." },
  { n: "06", title: "Professionisti per percorsi mirati", text: "Figure dedicate al benessere per accompagnarti oltre l'allenamento." },
];

export const services = [
  { title: "Sala Pesi", text: "Attrezzi, macchinari e coaching per un percorso costruito su di te.", to: "/sala-pesi", img: "weightRoom" },
  { title: "Personal Training", text: "Un professionista dedicato e un programma su misura.", to: "/personal-training", img: "personalTraining" },
  { title: "Corsi Fitness", text: "Lezioni dinamiche da 50 minuti, guidate da istruttori dedicati.", to: "/corsi-fitness", img: "fitnessClass" },
  { title: "Sala Olistica", text: "Yoga, Pilates, Posturale e Reformer per equilibrio e benessere.", to: "/sala-olistica", img: "holistic" },
  { title: "Kids & Family", text: "Il movimento come crescita, per bambini e famiglie.", to: "/kids-family", img: "kidsFamily" },
  { title: "Professionisti", text: "Osteopata, fisioterapista e nutrizionista per percorsi mirati.", to: "/professionisti", img: "reception" },
];

export const faqs = [
  { q: "La palestra è aperta H24?", a: "Sì, Body Evolution 2.0 sarà aperta H24 da settembre." },
  { q: "È possibile fare una prova gratuita?", a: "Sì, puoi richiedere una prova gratuita contattandoci tramite WhatsApp, telefono o form del sito." },
  { q: "Ci sono istruttori in sala?", a: "Sì, gli istruttori sono presenti dal lunedì al venerdì dalle 6:30 alle 23:00 e il sabato dalle 8:30 alle 18:30." },
  { q: "I corsi durano tutti 50 minuti?", a: "La maggior parte dei corsi ha una durata di 50 minuti. Gli orari aggiornati sono disponibili nelle singole pagine dei corsi." },
  { q: "Sono disponibili corsi per bambini?", a: "Sì, Body Evolution 2.0 sta definendo percorsi dedicati ai bambini, con attività pensate per movimento, disciplina, coordinazione e crescita." },
  { q: "Ci sono professionisti come nutrizionista, osteopata e fisioterapista?", a: "Sì, la palestra integra professionisti dedicati al benessere e ai percorsi mirati. I dettagli saranno disponibili su appuntamento." },
];

export const memberships = [
  { title: "Mensile", text: "La formula flessibile per iniziare il tuo percorso mese dopo mese." },
  { title: "Trimestrale", text: "Tre mesi di continuità per costruire una routine solida." },
  { title: "Semestrale", text: "Sei mesi di allenamento con costanza e risultati progressivi." },
  { title: "Annuale", text: "L'impegno completo, per chi vuole vivere la palestra tutto l'anno." },
  { title: "Sala Pesi", text: "Accesso alla sala pesi con attrezzi, macchinari e supporto istruttori." },
  { title: "Sala + Corsi", text: "La soluzione completa: sala pesi e tutto il palinsesto corsi." },
  { title: "Solo Corsi", text: "Dedicata a chi ama allenarsi con i corsi fitness e olistici." },
  { title: "Personal Training", text: "Pacchetti individuali con un professionista dedicato." },
  { title: "Kids", text: "Percorsi pensati per i più piccoli, tra movimento e crescita." },
  { title: "Family", text: "Una soluzione pensata per le famiglie che vogliono vivere il movimento insieme, con percorsi dedicati ad adulti e bambini." },
];

export const professionals = [
  { title: "Osteopata", text: "Supporto per mobilità, postura, tensioni muscolari e benessere generale." },
  { title: "Fisioterapista", text: "Percorsi dedicati a recupero funzionale, prevenzione infortuni e ritorno al movimento." },
  { title: "Nutrizionista", text: "Consulenze alimentari personalizzate per accompagnare allenamento, salute e obiettivi fisici." },
];

// Courses — category: fitness | olistica | balli
export const courses = [
  {
    slug: "functional", name: "Functional", category: "fitness",
    short: "Movimenti funzionali per forza, resistenza e coordinazione.",
    intro: "Un allenamento completo e dinamico che mette in movimento tutto il corpo, migliorando forza, resistenza, coordinazione e controllo.",
    audience: "Ideale per chi cerca un allenamento vario ed efficace, adatto a ogni livello di preparazione.",
    how: "Circuiti a corpo libero e con piccoli attrezzi, guidati da un istruttore che modula intensità e recupero.",
    benefits: ["Forza funzionale", "Resistenza", "Coordinazione", "Controllo del corpo"],
    schedule: [{ days: "Lun · Mer · Ven", time: "07:30" }, { days: "Venerdì", time: "11:00" }, { days: "Venerdì", time: "18:00 - 19:00" }],
  },
  {
    slug: "spinning", name: "Spinning", category: "fitness",
    short: "Cardio intenso su bike, a ritmo di musica.",
    intro: "Una lezione cardio intensa su bike, ideale per bruciare calorie, migliorare la resistenza e allenarti a ritmo di musica.",
    audience: "Perfetto per chi vuole un allenamento cardiovascolare coinvolgente e ad alto dispendio energetico.",
    how: "Sessioni su bike con variazioni di ritmo e resistenza, guidate dall'istruttore e scandite dalla musica.",
    benefits: ["Dispendio calorico", "Resistenza cardio", "Tono gambe", "Energia"],
    schedule: [{ days: "Lun · Mer · Ven", time: "09:00" }, { days: "Lun · Mer · Ven", time: "14:00" }],
  },
  {
    slug: "latin-fit", name: "Latin Fit", category: "fitness",
    short: "Fitness e ritmi latini per allenarti divertendoti.",
    intro: "Un corso energico e coinvolgente che unisce fitness e ritmi latini per allenarti divertendoti.",
    audience: "Per chi ama il movimento, la musica e vuole allenarsi con leggerezza ed energia.",
    how: "Coreografie semplici su ritmi latini, che uniscono cardio e divertimento.",
    benefits: ["Cardio", "Coordinazione", "Buonumore", "Resistenza"],
    schedule: [{ days: "Mar · Gio", time: "09:00" }],
  },
  {
    slug: "zumba", name: "Zumba", category: "fitness",
    short: "Allenamento musicale ad alta energia.",
    intro: "Un allenamento musicale ad alta energia, perfetto per migliorare coordinazione, resistenza e tono muscolare.",
    audience: "Adatto a tutti, per chi vuole allenarsi ballando e divertendosi.",
    how: "Coreografie di gruppo ad alta energia guidate da un istruttore dedicato.",
    benefits: ["Cardio", "Coordinazione", "Tono muscolare", "Divertimento"],
    schedule: [{ days: "Lun · Mer · Ven", time: "10:00" }, { days: "Mar · Gio", time: "19:00" }],
  },
  {
    slug: "gag", name: "GAG", category: "fitness",
    short: "Gambe, addominali e glutei: tonificazione mirata.",
    intro: "Un corso mirato su gambe, addominali e glutei, ideale per tonificare e migliorare la forma fisica.",
    audience: "Per chi vuole lavorare in modo mirato sulla tonificazione del corpo.",
    how: "Esercizi a corpo libero e con piccoli attrezzi focalizzati sui distretti muscolari chiave.",
    benefits: ["Tonificazione", "Glutei e gambe", "Core", "Resistenza"],
    schedule: [{ days: "Lunedì", time: "11:00" }, { days: "Mercoledì", time: "18:00 - 19:00" }],
  },
  {
    slug: "body-pump", name: "Body Pump", category: "fitness",
    short: "Bilancieri e carichi controllati per tutto il corpo.",
    intro: "Un allenamento con bilancieri e carichi controllati, pensato per tonificare tutto il corpo e migliorare forza e resistenza muscolare.",
    audience: "Per chi vuole tonificare e rinforzare con un lavoro strutturato sui carichi.",
    how: "Sequenze con bilanciere a ritmo di musica, con carichi modulabili per ogni livello.",
    benefits: ["Forza", "Tono totale", "Resistenza muscolare", "Postura"],
    schedule: [{ days: "Mercoledì", time: "11:00" }, { days: "Lunedì", time: "18:00 - 19:00" }],
  },
  {
    slug: "fit-box", name: "Fit Box", category: "fitness",
    short: "Corso dinamico ispirato alla boxe.",
    intro: "Un corso dinamico ispirato alla boxe, ideale per scaricare tensione, bruciare calorie e migliorare coordinazione e resistenza.",
    audience: "Per chi vuole scaricare stress e allenarsi con intensità e ritmo.",
    how: "Combinazioni di colpi su sacco e a vuoto, alternate a esercizi cardio e di potenziamento.",
    benefits: ["Scarico stress", "Cardio", "Coordinazione", "Resistenza"],
    schedule: [{ days: "Lun · Mer · Ven", time: "13:00" }, { days: "Lun · Mar · Mer · Gio · Ven", time: "17:00" }],
  },
  {
    slug: "step", name: "Step", category: "fitness",
    short: "Aerobica con step per fiato e coordinazione.",
    intro: "Una lezione aerobica con step, utile per migliorare fiato, coordinazione, tonicità e ritmo.",
    audience: "Per chi ama l'aerobica e vuole migliorare capacità cardiovascolare e coordinazione.",
    how: "Coreografie aerobiche sullo step, con progressioni guidate dall'istruttore.",
    benefits: ["Fiato", "Coordinazione", "Tonicità", "Ritmo"],
    schedule: [{ days: "Mar · Gio", time: "13:00" }, { days: "Mar · Gio", time: "18:00" }],
  },
  {
    slug: "mma", name: "MMA", category: "fitness",
    short: "Arti marziali miste: tecnica, disciplina e controllo.",
    intro: "Un corso dedicato alle arti marziali miste, pensato per sviluppare tecnica, disciplina, forza, agilità e controllo.",
    audience: "Per chi vuole avvicinarsi alle arti marziali e migliorare tecnica e condizione fisica.",
    how: "Lavoro tecnico, condizionamento e sparring controllato guidati da un istruttore.",
    benefits: ["Tecnica", "Disciplina", "Forza", "Agilità"],
    schedule: [{ days: "Lun · Mer · Ven", time: "20:00 - 21:00" }],
  },
  {
    slug: "difesa-personale", name: "Difesa Personale", category: "fitness",
    short: "Sicurezza, consapevolezza e reattività.",
    intro: "Un percorso pratico per migliorare sicurezza, consapevolezza, reattività e gestione del corpo in situazioni di difesa.",
    audience: "Per chiunque voglia acquisire strumenti pratici di sicurezza e consapevolezza.",
    how: "Tecniche pratiche e simulazioni guidate, con attenzione alla gestione delle situazioni reali.",
    benefits: ["Sicurezza", "Consapevolezza", "Reattività", "Controllo"],
    schedule: [{ days: "Mar · Gio", time: "20:00 - 21:00" }],
  },
  {
    slug: "total-body", name: "Total Body", category: "fitness",
    short: "Allenamento completo per tutto il corpo.",
    intro: "Un allenamento completo per tutto il corpo, ideale per tonificare, bruciare calorie e migliorare la condizione fisica generale.",
    audience: "Per chi cerca un allenamento globale ed efficace, adatto a ogni livello.",
    how: "Circuiti total body che alternano lavoro cardio e di tonificazione.",
    benefits: ["Tono totale", "Dispendio calorico", "Resistenza", "Forma fisica"],
    schedule: [{ days: "Orari da confermare", time: "—" }],
  },
  // Balli
  {
    slug: "caraibico", name: "Caraibico", category: "balli",
    short: "Balli caraibici tra ritmo, energia e divertimento.",
    intro: "Un corso dedicato ai balli caraibici, pensato per vivere il movimento con ritmo, energia e divertimento.",
    audience: "Per chi ama la musica caraibica e vuole allenarsi ballando.",
    how: "Passi e figure di coppia e di gruppo su ritmi caraibici, guidati dall'istruttore.",
    benefits: ["Ritmo", "Coordinazione", "Socialità", "Energia"],
    schedule: [{ days: "Lun · Mer", time: "21:00" }],
  },
  {
    slug: "tango", name: "Tango", category: "balli",
    short: "Eleganza, connessione ed espressività del movimento.",
    intro: "Un percorso elegante e coinvolgente, dedicato al controllo del corpo, alla connessione e all'espressività del movimento.",
    audience: "Per chi cerca un percorso raffinato tra movimento, postura ed espressività.",
    how: "Tecnica e figure di tango con attenzione a postura, equilibrio e connessione.",
    benefits: ["Controllo del corpo", "Postura", "Espressività", "Eleganza"],
    schedule: [{ days: "Mar · Gio", time: "21:00" }],
  },
  // Olistica
  {
    slug: "yoga", name: "Yoga", category: "olistica",
    short: "Respirazione, equilibrio, mobilità e benessere mentale.",
    intro: "Un percorso dedicato a respirazione, equilibrio, mobilità e benessere mentale, ideale per ritrovare energia e consapevolezza.",
    audience: "Per chi cerca equilibrio, mobilità e una connessione profonda con il proprio corpo.",
    how: "Sequenze di asana, respirazione e rilassamento guidate in un ambiente sereno.",
    benefits: ["Respirazione", "Equilibrio", "Mobilità", "Benessere mentale"],
    schedule: [{ days: "Lun · Mer · Ven", time: "07:30" }, { days: "Lun · Mer · Ven", time: "20:00" }],
  },
  {
    slug: "pilates", name: "Pilates", category: "olistica",
    short: "Postura, tono, controllo e stabilità.",
    intro: "Una disciplina elegante e controllata, ideale per migliorare postura, tono muscolare, controllo del corpo e stabilità.",
    audience: "Per chi vuole lavorare su postura, core e controllo del movimento.",
    how: "Esercizi controllati a corpo libero e con piccoli attrezzi, focalizzati sul core.",
    benefits: ["Postura", "Tono", "Controllo", "Stabilità"],
    schedule: [{ days: "Lun · Mer · Ven", time: "08:30 - 09:30" }, { days: "Mar · Gio", time: "09:30 - 11:30" }, { days: "Mar · Gio", time: "17:00 - 20:00" }],
  },
  {
    slug: "posturale", name: "Posturale", category: "olistica",
    short: "Postura, mobilità e qualità del movimento quotidiano.",
    intro: "Un corso orientato al miglioramento della postura, della mobilità e della qualità del movimento quotidiano.",
    audience: "Per chi vuole prendersi cura della postura e del benessere della schiena.",
    how: "Esercizi di mobilità, allungamento e rinforzo mirati alla postura.",
    benefits: ["Postura", "Mobilità", "Benessere", "Qualità del movimento"],
    schedule: [{ days: "Mar · Gio", time: "08:30" }, { days: "Lun · Mer · Ven", time: "15:00 - 17:00" }],
  },
  {
    slug: "reformer", name: "Reformer", category: "olistica",
    short: "Controllo, forza profonda, postura e precisione.",
    intro: "Un allenamento su Reformer, ideale per lavorare su controllo, forza profonda, postura, mobilità e precisione del movimento.",
    audience: "Per chi cerca un lavoro di precisione su forza profonda, postura e controllo.",
    how: "Esercizi sul macchinario Reformer, guidati con attenzione alla tecnica.",
    benefits: ["Controllo", "Forza profonda", "Postura", "Precisione"],
    schedule: [{ days: "Lun · Mer · Ven", time: "10:30 - 12:30" }, { days: "Lun · Mar · Mer · Gio · Ven", time: "12:30" }, { days: "Mar · Gio", time: "15:00 - 16:00" }, { days: "Lun · Mer · Ven", time: "18:00 - 19:00" }],
  },
];

export const courseBySlug = (slug) => courses.find((c) => c.slug === slug);
export const coursesByCategory = (cat) => courses.filter((c) => c.category === cat);
